// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import OrderDetail from '../components/OrderDetail';
import {actions as OrderAction} from '../../order/duck';
import {actions as OrdersAction} from '../../orders/duck';
import {actions as ReviewsAction} from '../../marketing/reviews/duck';
import {actions as PaymentMethodsActions} from '../../configure/payment-method/duck';
import {actions as ManualOrderActions} from '../../manual-order/duck';
import {actions as CouponsActions} from '../../marketing/coupons/duck';
import {actions as SalesProcessActions} from '../../configure/sales-process/duck';
import {actions as AccountsActions} from '../../configure/accounts/duck';

import type {RootState} from '../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    user: state.auth.user,
    order: state.order.order,
    isFetching: state.order.isFetching,
    fetchError: state.order.fetchError,
    orderStockErrors: state.order.orderStockErrors,
    isFetchingOrderStockErrors: state.order.isFetchingOrderStockErrors,
    fetchOrderStockErrorsSuccess: state.order.fetchOrderStockErrorsSuccess,
    isSaving: state.order.isSaving,
    updateOrderStateSuccess: state.order.updateOrderStateSuccess,
    updateOrderStateError: state.order.updateOrderStateError,
    store: state.store.store,
    sendEmailSuccess: state.reviews.sendEmailSuccess,
    paymentMethod: state.paymentMethodConfig.paymentMethod,
    paymentMethods: state.paymentMethodConfig.paymentMethods,
    information: state.ui.storeInformation,
    editOrderSuccess: state.manualOrder.editOrderSuccess,
    editOrderError: state.manualOrder.editOrderError,
    coupons: state.coupons.coupons,
    orderStateMessages: state.salesProcessConfig.orderStateMessages,
    currency: state.currency.currency,
    collaborators: state.accountsConfig.collaborators,
    collaborator: state.accountsConfig.collaborator,
    orderComments: state.order.orderComments,
    saveOrderCommentSuccess: state.order.saveOrderCommentSuccess,
    deleteOrderCommentSuccess: state.order.deleteOrderCommentSuccess,
    updateOrderCommentSuccess: state.order.updateOrderCommentSuccess,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...OrderAction,
        ...ReviewsAction,
        ...PaymentMethodsActions,
        ...CouponsActions,
        ...SalesProcessActions,
        ...AccountsActions,
        resetManualOrderState: ManualOrderActions.resetState,
        resetPartialFilters: OrdersAction.resetPartialFilters,
      },
      dispatch
    )
)(OrderDetail);
